var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 4.60976L4.9434 9L12 1","stroke":"#42C296","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckInline.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
